import React from "react";
import {Card, Stepper} from "tea-component";
import {useDblIntl} from "@/pages/datalab/utils/utils";


export default function () {
	const {dblFormatMessage: gptFormatMessage, isEn} = useDblIntl("gpt_home_guide");
	const steps = [
		{
			id: "first",
			label: gptFormatMessage("first_title"),
			detail: (<>
				<p className={"description"}>{gptFormatMessage("first_des")}</p>
				<p className={"first-example"}><span className={"label"}>{gptFormatMessage("first_input")}</span><span className={"text"} dangerouslySetInnerHTML={{__html: gptFormatMessage("first_input_question")}}/></p>
				<p className={"first-example"}><span className={"label"}>{gptFormatMessage("first_AI")}</span><span className={"text"} dangerouslySetInnerHTML={{__html: gptFormatMessage("first_AI_answer")}}/></p>
			</>)
		},
		{
			id: "second",
			label: gptFormatMessage("second_title"),
			detail: (<>
				<p className={"description"}>{gptFormatMessage("second_des")}</p>
				<img className="second-img" src={require("@/pages/datalab/assets/img/chat-home-sql.png")}/>
			</>)
		},
		{
			id: "third",
			label: gptFormatMessage("third_title"),
			detail: (<>
				<p className={"description"}>{gptFormatMessage("third_des")}</p>
				<img className="second-img" src={require("@/pages/datalab/assets/img/chat-home-bar.png")}/>
				<div className={"tea-step__arrow"}></div>
			</>)
		},
	]
	return (
		<Card className={"dbl-gpt-home-guid"}>
			<Card.Body title={<div className={"dbl-title-16"}>{gptFormatMessage("title")}</div>}>
				<Stepper type="process-vertical" steps={steps} />
			</Card.Body>
		</Card>
	)
	
}
